import { DEFAULT_NOTE_TYPES, NOTE_STATUS } from "@/services/api";
import { PersonRecord } from "@/common/PersonRecord";
import { handleFullName } from "@/shared/utils/handle-contacts-null";
import { useRuntimeImage } from "@/entities/runtime-image";
import { getRowTextColor } from "@/entities/notes-table-v3/lib/get-row-text-color";
import type { FC } from "react";
import type { NotesTableRowData } from "@/entities/notes-table-v3/model/types/notes-table-types";
import styles from "./styles.module.scss";

type Props = {
  record: NotesTableRowData;
  colorize?: boolean;
};

export const PersonTableRecord: FC<Props> = ({ record, colorize }) => {
  const { getRuntimeImageURL } = useRuntimeImage();
  return (
    <div className={styles.wrapper}>
      <PersonRecord
        avatar={getRuntimeImageURL({ fileId: record.person?.avatarFile?.fileId ?? "" })}
        textColor={getRowTextColor(
          record,
          colorize && DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT === record.noteType.name,
        )}
        disabled={
          record.status === NOTE_STATUS.DONE &&
          record.noteType.name === DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT
        }
        group={record?.person?.group ?? ""}
        name={handleFullName(record?.person?.firstName, record?.person?.lastName)}
        selected={false}
      />
    </div>
  );
};
